import { combineSlices } from '@reduxjs/toolkit';
import { generalSlice } from './general';
import { uiSlice } from './ui';
import { dateSlice } from './date';
import { locationSlice } from './location';
import { productSlice } from './product';
import { translationSlice } from './translation';

export default combineSlices(
  dateSlice,
  generalSlice,
  locationSlice,
  productSlice,
  translationSlice,
  uiSlice,
);
